(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-carousel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function(){
  var sliders = document.querySelectorAll('.image-carousel');
  if(sliders.length && window.jQuery){
    sliders.forEach(function(slider){
      $(slider).slick({
        slidesToShow: parseInt(slider.dataset.slidesToShow) || 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2500,
        arrows: true,
        dots: false,
        infinite: true,
        responsive: [
          { breakpoint: 1024, settings: { slidesToShow: 2 } },
          { breakpoint: 600, settings: { slidesToShow: 1 } }
        ]
      });
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
